var _classCallCheck = require("C:\\Users\\Vithuran Sadagopan\\Documents\\blockvote\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Vithuran Sadagopan\\Documents\\blockvote\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var address = require("./encoding/address");

var encoding = require("./encoding/encoding");

var nacl = require("./nacl/naclWrappers");

var utils = require("./utils/utils");
/**
 * Bid enables construction of Algorand Auctions Bids
 * */


var Bid =
/*#__PURE__*/
function () {
  "use strict";

  function Bid(_ref) {
    var bidderKey = _ref.bidderKey,
        bidAmount = _ref.bidAmount,
        maxPrice = _ref.maxPrice,
        bidID = _ref.bidID,
        auctionKey = _ref.auctionKey,
        auctionID = _ref.auctionID;

    _classCallCheck(this, Bid);

    this.name = "Bid";
    this.tag = Buffer.from([97, 66]); // "aB"

    bidderKey = address.decode(bidderKey);
    auctionKey = address.decode(auctionKey);
    if (!Number.isSafeInteger(bidAmount) || bidAmount < 0) throw Error("Bid amount must be positive and 2^53-1");
    if (!Number.isSafeInteger(bidID) || bidID < 0) throw Error("BidID must be positive and 2^53-1");
    if (!Number.isSafeInteger(auctionID) || auctionID < 0) throw Error("auctionID must be positive");
    Object.assign(this, {
      bidderKey: bidderKey,
      auctionKey: auctionKey,
      bidAmount: bidAmount,
      maxPrice: maxPrice,
      bidID: bidID,
      auctionID: auctionID
    });
  }

  _createClass(Bid, [{
    key: "get_obj_for_encoding",
    value: function get_obj_for_encoding() {
      return {
        "bidder": Buffer.from(this.bidderKey.publicKey),
        "cur": this.bidAmount,
        "price": this.maxPrice,
        "id": this.bidID,
        "auc": Buffer.from(this.auctionKey.publicKey),
        "aid": this.auctionID
      };
    }
  }, {
    key: "signBid",
    value: function signBid(sk) {
      var encodedMsg = encoding.encode(this.get_obj_for_encoding());
      var toBeSigned = Buffer.from(utils.concatArrays(this.tag, encodedMsg));
      var sig = nacl.sign(toBeSigned, sk); // construct signed message

      var sBid = {
        "sig": Buffer.from(sig),
        "bid": this.get_obj_for_encoding()
      };
      var note = {
        "t": "b",
        "b": sBid
      };
      return new Uint8Array(encoding.encode(note));
    }
  }]);

  return Bid;
}();

module.exports = {
  Bid: Bid
};